import React from 'react';
import ArrowTopRight from '@app/components/icons/arrow-top-right';
import { TeamPageAttributes } from '@app/models/dtos/strapi';
import { useRouter } from 'next/router';
import AnchorLink from '@app/components/ui/links/anchor-link';

function WorkWithUs({ teamsPageDetailsAttributes }: { teamsPageDetailsAttributes: TeamPageAttributes }) {
    const router = useRouter();
    return (
        <div className="mt-[60px] md:mt-[160px] ">
            <p className="P2 text-black-1">Wanna Work With Us?</p>
            <p className="h4-responsive mb-4 mt-6 max-w-[714px] text-black-1" dangerouslySetInnerHTML={{ __html: teamsPageDetailsAttributes.workWithUsTitle }}></p>
            <p className="P2 max-w-[486px] text-black-2">{teamsPageDetailsAttributes.workWithUsDescription}</p>
            <AnchorLink href={'/career/openings'} className="mt-6 flex items-center gap-2 decoration-blue">
                <span className="P1 !text-blue">See Our Current Openings</span>
                <ArrowTopRight className="h-3 w-3 text-blue " />
            </AnchorLink>
        </div>
    );
}

export default WorkWithUs;
